<template>
    <div>
        <dialog-loader v-show="this.loading" />
        <div v-if="!this.loading">
            <div class="flex xs12 lg10 offset-lg1" style="display:flex; justify-content: space-between">
                <h2>Demandas Avaliadas</h2>
                <v-btn @click="$router.go(-1)">Voltar</v-btn>
            </div>

            <app-sercheable-data-table
                :headers="headers"
                :search="search"
                :pagination="pagination"
                :placeholder="placeholder"
            >
                <template slot="items" slot-scope="{ item }">
                    <router-link v-if="item.evaluationComments.length > 0" :to="{ name: 'officeEvaluatedDemandComments', params: { demandId: item.id }}" tag="tr">
                        <td>{{ item.code }}</td>
                        <td>{{ item.system.acronym }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.type.name }}</td>
                        <td><strong>{{ item.evaluationAverage }}</strong></td>
                        <td>
                            <strong>Sim</strong>
                        </td>
                    </router-link>
                    <router-link v-else :to="{ name: 'officeEvaluatedDemands', params: { demandId: item.id }}" tag="tr">
                        <td>{{ item.code }}</td>
                        <td>{{ item.system.acronym }}</td>
                        <td>{{ item.title }}</td>
                        <td>{{ item.type.name }}</td>
                        <td><strong>{{ item.evaluationAverage }}</strong></td>
                        <td>
                            <label>Não</label>
                        </td>
                    </router-link>

                </template>
            </app-sercheable-data-table>
        </div>
    </div>
</template>

<script>
import utilities from "@/helpers/utilities";
import SercheableDataTable from "../shared/SercheableDataTable";
import DialogLoader from '../shared/DialogLoader';

export default {
    data() {
        return {
            pagination: {
                descending: true,
                sortBy: "code"
            },
            headers: [
                {
                    text: this.$t("label.code"),
                    value: "code",
                    align: "left"
                },
                {
                    text: this.$t("label.system"),
                    value: "system.acronym",
                    align: "left"
                },
                {
                    text: this.$t("label.name"),
                    value: "title",
                    align: "left"
                },
                {
                    text: this.$t("label.demandType"),
                    value: "type.name",
                    align: "left"
                },
                {
                    text: this.$t("label.averageEvaluationDemands"),
                    value: "evaluationAverage",
                    align: "left"
                },
                {
                    text: this.$t("label.comments"),
                    value: "evaluationComments",
                    align: "left"
                },
            ],
            loading: true,
        };
    },

    components: {
        appSercheableDataTable: SercheableDataTable,
        DialogLoader
    },

    methods: {
        search(filters) {
            const demands = this.$store.getters.evaluatedDemandsGrid;

            return utilities.filterMultiple(
                demands,
                filters,
                (demand, regex) =>
                    regex.test(demand.code.toString()) ||
                    regex.test(demand.system.acronym) ||
                    regex.test(demand.title) ||
                    regex.test(demand.type.name) ||
                    regex.test(demand.evaluationAverage)
            );
        },
        async getEvaluatedDemands() {
            this.loading = true;
            const id = this.$route.params.officeId;

            if (!utilities.isEmptyOrZero(id)) {
                await this.$store.dispatch("loadEvaluatedDemandsGrid", id);
            }

            this.loading = false;
        }
    },
    beforeMount() {
        this.getEvaluatedDemands();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/officesScore/EvaluatedDemands.vue